<template>
  <div>
    <v-layout v-if="count.length>0" wrap>
      <v-flex py-6 v-for="(item, i) in count" :key="i" xs12 lg4>
        <v-card color="transparent" tile flat>
          <v-layout  wrap>
            <v-flex lg2> </v-flex>
            <v-flex text-center xs12 lg8>
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 18px;
                  color:  #e6e6e6;
                  letter-spacing: 2px;
                "
                >{{ item.count }}</span
              >
            </v-flex>
            <v-flex lg2> </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex lg2> </v-flex>
            <v-flex v-if="item.icon" text-center xs12 lg8 >
              <v-icon color="#ffffff">{{ item.icon }}</v-icon>
            </v-flex>
            <v-flex v-else text-center xs12 lg8 >
              <v-icon color="#ffffff">mdi-thumb-up-outline</v-icon>
            </v-flex>
            <v-flex lg2> </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex lg2> </v-flex>
            <v-flex text-center xs12 lg8>
              <span
                style="
                  font-family: poppinslight;
                  font-size: 16px;
                  color: #ffffff;
                  letter-spacing: 2px;
                "
                >{{ item.name }}</span
              >
              <v-flex lg2> </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      count:[],
    };
  },
  mounted: function () {
    this.getCounts();
  },
  methods: {
    getCounts() {
      axios({
        method: "GET",
        url: "/homepage/count/list",
      })
        .then((response) => {
          if(response.data.status)
          this.count = response.data.data;
          // for(var i=0;i<this.count.length;i++)
          // {
          //   this.count[i].icon="mdi-thumb-up-outline"
          // }
        })
        .catch(() => {});
    },
  },
};
</script>